import { render, staticRenderFns } from "./AtividadesRealizadasEvolui.vue?vue&type=template&id=1de45641&scoped=true"
import script from "./AtividadesRealizadasEvolui.vue?vue&type=script&lang=js"
export * from "./AtividadesRealizadasEvolui.vue?vue&type=script&lang=js"
import style0 from "./AtividadesRealizadasEvolui.vue?vue&type=style&index=0&id=1de45641&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de45641",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VRow})
